<template>
  <Main>
    <v-row>
      <v-col cols="12" sm="8" md="9" class="pr-sm-5">
        <BaseFilter
          v-model="search"
          v-bind="filterProps"
          textPlaceholder="Buscar usuários"
          @search="searchByFilter"
          v-on:keyup="searchByFilterClickEnter"
        />
      </v-col>
      <v-col cols="12" sm="4" md="3" class="mb-5">
        <BaseButton
          class="secondary text-uppercase subtitle-2 font-weight-bold"
          style="width: 100%"
          @click="goToUserNew()"
        >
          <v-icon class="pr-4 add-icon">fa-plus</v-icon>
          Novo usuário
        </BaseButton>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="users.items"
          :server-items-length="users.total_count"
          no-data-text="Não há usuários cadastrados."
          loading-text="Carregando usuários..."
          :options.sync="options"
          :loading="listLoading"
          class="user-table base__datatable"
          @click:row="goToUserDetails"
        >
          <template v-slot:[`item.nome`]="{ item }">
            <div :class="borderColor(item.status.id)">
              <div class="user-table__padding">
                {{ item.nome }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.eh_escritorio`]="{ item }">
            {{ item.eh_escritorio ? "Sim" : "Não" }}
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
  </Main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};

const tableHeaders = [
  { text: "Nome", value: "nome", sortable: true },
  { text: "Perfil", value: "perfil.nome", sortable: true },
  { text: "Estrutura de Acesso", value: "estrutura.nome", sortable: false },
  { text: "Escritório?", value: "eh_escritorio", sortable: false },
  { text: "Status", value: "status.nome", sortable: false }
];

const colorByStatus = {
  ativo: { color: "light-blue" },
  inativo: { color: "pink" }
};

export default {
  name: "UserList",
  mixins: [LoadingRequest, CommonPayload],
  computed: {
    ...mapState("user", ["users"])
  },
  data: () => ({
    search: "",
    filterProps: defaultFilterProps,
    options: defaultFilterOptions(),
    tableHeaders,
    listLoading: false
  }),
  watch: {
    options: {
      handler(value) {
        this.fetchData(this.getPayload(value));
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("user", ["requestUserList"]),
    borderColor(status) {
      const { color } = colorByStatus[status];
      return `user-table__border-${color}`;
    },
    searchByFilter() {
      this.withLoading(this.requestUserList(this.getPayload(this.options)));
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13)
        this.withLoading(this.requestUserList(this.getPayload(this.options)));
    },
    fetchData(payload) {
      this.withLoading(this.requestUserList(payload));
    },
    goToUserDetails(item) {
      this.saveOptionsDataTable(this.payloadOptions());
      this.$router.push({ name: "user details", params: { userId: item.id } });
    },
    goToUserNew() {
      this.saveOptionsDataTable(this.payloadOptions());
      this.$router.push({ name: "user new" });
    },
    getPayload(options) {
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const direction =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      return {
        page,
        page_size: itemsPerPage,
        sort,
        direction,
        query: this.search
      };
    },
    mounted() {
      this.fetchData(this.getPayload(this.options));
    }
  }
};
</script>

<style lang="sass">
.user-table
  &__border-light-blue
    border-left: 5px solid #49DCBB
  &__border-pink
    border-left: 5px solid #EF5350
  &__padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
  &.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
    tbody tr td:first-child
      padding: 2px 0px !important
</style>
